import { Box, Button, HStack } from "@chakra-ui/react";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { Dispatch, SetStateAction } from "react";

type MessageHeaderProps = {
  setClickedRecord: Dispatch<SetStateAction<any>>;
};

const MessageHeader = ({ setClickedRecord }: MessageHeaderProps) => (
  <HStack
    w="100%"
    justifyContent="space-between"
    padding="1rem 0"
    borderTop="1px solid var(--grey-300)"
  >
    <Button variant="none" display="flex" alignItems="center" gap="0.63rem">
      <Box
        as="span"
        display="flex"
        alignItems="center"
        borderRadius="0.5rem"
        border="1px solid var(--grey-300)"
        padding="0.38rem"
        onClick={() => setClickedRecord(null)}
      >
        <ChevronLeftIcon
          style={{
            width: "1.25rem",
            height: "1.25rem",
            color: "black",
          }}
        />
      </Box>
      Back
    </Button>
  </HStack>
);

export default MessageHeader;
